import * as React from 'react';
import DataGrid from '../components/DataGrid';
import GetColumnDefs from '../components/ColumnDefs';
import { GetPermissions } from '../components/Options';
import { DateRangePicker } from '@progress/kendo-react-dateinputs';
import { useNavigate } from "react-router-dom";
import { DropDownList } from '@progress/kendo-react-dropdowns';

// DatabaseLogger stores wall-clock timestamps; preserve the selected calendar dates.
const localDate = (date) => `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T00:00:00`;

const SystemLogs = () => {
    const [columns, setColumns] = React.useState(null);
    const [permissions, setPermissions] = React.useState(null);
    const navigate = useNavigate();
    const levels = ["All", "Information", "Warning", "Error", "Critical"];
    if (localStorage.getItem("userid") === null) navigate("/logout");
    const subTotals = [];
    let dr = JSON.parse(localStorage.getItem('SystemLogDates'));
    if (dr !== null) {
        if (dr.start !== null) dr.start = new Date(dr.start);
        if (dr.end !== null) dr.end = new Date(dr.end);
    } else {
        let dt = new Date();
        dr = { start: new Date(dt.getFullYear(), dt.getMonth(), dt.getDate()), end: null };
        localStorage.setItem("SystemLogDates", JSON.stringify(dr));
    }

    const rangeChanged = (event) => {
        ChangeRange(event.target.value, level);
    }

    const ChangeRange = (dr, l = "All") => {
        setDateRange(dr);
        localStorage.setItem("SystemLogDates", JSON.stringify(dr));
        var params = {
            FromDate: dr.start === null ? null : localDate(dr.start),
            ToDate: dr.end === null ? null : localDate(dr.end),
            Other: l
        };
        setLookupParams(encodeURIComponent(JSON.stringify(params)));
    }

    const levelChanged = (event) => {
        setLevel(event.target.value);
        ChangeRange(dateRange, event.target.value);
    }

    const [dateRange, setDateRange] = React.useState(dr);
    const [level, setLevel] = React.useState("All");
    const [lookupParams, setLookupParams] = React.useState("");
    React.useEffect(() => {
        GetColumnDefs("SystemLogs", setColumns);
        GetPermissions(["ViewPrintEventLog"], setPermissions);
        ChangeRange(dateRange, level);
    }, [])


    if (permissions && !permissions.CanView) navigate("/");

    return (
        <div>
            <div style={{ paddingTop: "20px" }}>
                {permissions && permissions.CanView && <div className="row" style={{ padding: "5px 10px" }}>
                    <div className="col-md-4" style={{ marginLeft: "30px" }} >
                        <DateRangePicker id="DateRange" value={dateRange} format="dd/MM/yyyy" onChange={rangeChanged}
                            startDateInputSettings={{ label: "Date - Start" }}
                            endDateInputSettings={{ label: "Date - End" }}
                        />
                    </div>
                    <div className="col-md-3" style={{ paddingTop: "7px", marginLeft: "-70px" }} >
                        <label className="control-label">Level</label>
                        <DropDownList id="Level" data={levels} value={level} onChange={levelChanged} />
                    </div>
                </div>}
            </div>
            {columns && permissions && permissions.CanView && lookupParams && <DataGrid key={lookupParams} dataSource='apiv7/private/getlogs' columns={columns} permissions={permissions} params={lookupParams} keyField="id" subTotals={subTotals}  />}
        </div>
    );

}

export default SystemLogs;
